import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { store } from '../../redux/oldStore';
import { ICertificateInfo } from './CertificateTypes';
import { toast } from 'react-toastify';
import './CertificateStyles.css';
import Icon, { IconType } from '../Icon/Icon';

interface IProps {}

const VolunteerCertificate = (props: IProps) => {
  const { userId } = useParams<{ userId: string }>();
  const [certificateInfo, setCertificateInfo] = useState<ICertificateInfo | null>(null);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = '@media print { @page { size: landscape; margin: 0; } body { zoom: 0.8; } }';
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    // Initialization logic here
    store.server
      .getApi2<ICertificateInfo>(`/certificate/volunteer/${userId}`)
      .then((x) => {
        if (x.Success) {
          setCertificateInfo(x.Value);
        } else {
          console.error('Failed to fetch certificate info:', x.Message);
          toast.error('Failed to fetch certificate info.');
        }
      })
      .catch((err) => {
        console.error('Error fetching certificate info:', err);
        toast.error('Error fetching certificate info.');
      });
  };

  if (!userId) {
    return (
      <>
        <h1>No User ID Provided</h1>
        <p>Please provide a valid user ID to generate the volunteer certificate.</p>
      </>
    );
  }

  return (
    <div>
      {certificateInfo ? (
        <div className="certificate-holder">
            <div className='cert-download no-print'>
                <a href={`/Certificate/Download/${userId}`} target="_blank">
                   <Icon type={IconType.download} /> Download Certificate
                </a>
            </div>
            { certificateInfo.Logo && <div className='cert-logo'>
                <img src={certificateInfo.Logo} alt="Event Logo" />
            </div>}
            <div className='cert-title'>{certificateInfo.Title}</div>
            <div className='cert-subTitle'>{certificateInfo.SubTitlePreName}</div>
            <div className='cert-name'>{certificateInfo.Name}</div>
            <div className='cert-subTitle'>{certificateInfo.SubTitlePostName}</div>
            <div className='cert-eventName'>{certificateInfo.EventName}</div>
            <div className='cert-date-sign-line'>
                <div className='cert-date'>{certificateInfo.CertificateDateString}</div>
                <div className='cert-signature'>
                    {certificateInfo.SignatureUrl && <img src={certificateInfo.SignatureUrl} alt="Signature" />}
                    <div className='cert-signer-name'>{certificateInfo.SignersPrintedName}</div>
                </div>
            </div>
        </div>
      ) : (
        <p>Loading certificate information...</p>
      )}
    </div>
  );
};

export default VolunteerCertificate;
